import {
    ChangeDetectionStrategy,
    Component,
    Input,
    ViewEncapsulation,
} from '@angular/core';
import {
    ILicenseDefinition,
    WARNING_LEVELS,
} from '@components/shared/license/license.constants';
import { ILicense } from '@models';

const LARGE = 128;
const SMALL = 64;

@Component({
    selector: 'ui-license-usage',
    templateUrl: './ui-license-usage.component.html',
    styleUrls: ['./ui-license-usage.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class UiLicenseUsageComponent {
    @Input()
    public license!: ILicense;

    @Input()
    public licenseInfo!: ILicenseDefinition;

    @Input()
    public isHost!: boolean;

    @Input()
    public get size() {
        return this._size;
    }
    public set size(value: 'small' | 'large' | undefined) {
        if (
            !value ||
            this._size === value
        ) { return; }

        this._size = value;
        const newDiameter =
            value === 'small' ?
                SMALL :
                LARGE;
        this.diameter = newDiameter;
    }

    public diameter = LARGE;

    public warningLevels = WARNING_LEVELS;

    private _size: 'small' | 'large' = 'large';

}
